export default __webpack_public_path__ + "static/media/pics (1).d898b343.svg";